export let PermissionType;
(function (PermissionType) {
  PermissionType["ALL"] = "ALL";
  PermissionType["USER"] = "USER";
  PermissionType["TEAM"] = "TEAM";
})(PermissionType || (PermissionType = {}));